import {
  Accordion,
  AccordionDetails,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ClientModel from "../../core/api/clients/ClientModel";
import Pagination from "../../core/api/PageRequest";
import { useClientFilter } from "../../hooks/ClientFilterProvider";
import { GoToPagination } from "../GoToPagination";
import ClientTable from "./ClientTable";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { translations } from "../../translations/common";
import {
  AccordionSummary,
  AccordionRoot,
  AccordionHeading
} from "./styles/ClientTableAccordion.styles";

const parsePagination = (search: string): Pagination => {
  const params = new URLSearchParams(search);
  const pageNo = parseInt(params.get("page") || "0");
  return { page: pageNo, size: 5 };
};

export default function ClientTableAccordion() {
  const location = useLocation();
  const clientFilterProvider = useClientFilter();

  const [clients, setClients] = useState<ClientModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [pagination, setPagination] = useState<Pagination>(
    parsePagination(location.search)
  );

  useEffect(() => {
    setPagination(parsePagination(location.search));
  }, [location.search]);

  const fetchClients = useCallback(async () => {
    setIsLoading(true);
    try {
      const clientPage = await ClientModel.emailClientList(
        {
          ...clientFilterProvider.filter,
        },
        pagination
      );
      setTotalCount(clientPage.page.totalElements);
      setClients(clientPage.content);
    } catch (error) {
      console.error('Failed to fetch clients:', error);
    } finally {
      setIsLoading(false);
    }
  }, [pagination, clientFilterProvider.filter]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={translations.clientTableAccordion.ariaControls}
        id={translations.clientTableAccordion.headerId}
      >
        <AccordionHeading>
          {translations.clientTableAccordion.selectedClients(totalCount)}
        </AccordionHeading>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionRoot>
          <ClientTable
            clients={clients}
            isLoading={isLoading}
            pageSize={pagination.size}
            refresh={fetchClients}
            slots={{
              pagination: () => (
                <GoToPagination
                  count={totalCount}
                  rowsPerPageOptions={[5]}
                  pageSize={pagination.size}
                />
              ),
            }}
          />
        </AccordionRoot>
      </AccordionDetails>
    </Accordion>
  );
}
